"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../../styled-components");
const Base_1 = require("../Base");
const Visible = ({ size = 16, fill, name, }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(Base_1.Base, { size: size, fill: fill !== null && fill !== void 0 ? fill : theme.icon, smooth: true },
        react_1.default.createElement("title", null, name),
        react_1.default.createElement("path", { d: "M8 4.8A3.2 3.2 0 0 0 4.8 8c0 1.7 1.5 3.1 3.2 3.1 1.7 0 3.2-1.3 3.2-3.1S9.8 4.8 8 4.8z\n      M8 3c2.9 0 5.4 2 7 5-1.6 3-4.1 5-7 5-2.9 0-5.4-2-7-5 1.6-3 4.1-5 7-5z" })));
};
exports.default = Visible;
//# sourceMappingURL=index.js.map